<script setup lang="ts">
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'

defineOptions({
  name: 'InfoChangeSchedule',
})

</script>

<template>
  <ListTaskInfo class="hidden" />
</template>
